import { Form, message } from 'antd';
import React, { useEffect, useState } from 'react';

import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneZip from 'components/dropzoneUpload/DropZoneZip';
import SmallModal from 'components/form/SmallModal';
import SubmitButton from 'components/button/SubmitButton';
import VerticalForm from 'components/form/DefaultForm';
import { platformImageZipUpload } from 'apis/operation/platformImageApis';
import { useTranslation } from 'react-i18next';

/**
 *
 * @param {*} props
 * @returns {플랫폼 이미지 - 압축파일(zip) 업로드 모달}
 */
const PlatformImgZipUploadModal = ({
  visible,
  setVisible,
  fetchData,
  optionList,
  selectDesignType,
  setSelectDesignType,
}) => {
  const { t } = useTranslation();
  const [inputDatas, setInputDatas] = useState({ design_type: '' });
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  const handleClose = () => {
    setVisible(false);
    setFile(null);
    Form.resetFields();
  };
  /// 이미지 타입 드롭다운 이벤트
  const handleChangeDesignType = (value) => {
    setInputDatas({ ...inputDatas, design_type: value });
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('uploadFile', file);
    formData.append('image_name', inputDatas.image_name);
    formData.append('design_type', inputDatas.design_type);

    // const res = await platformImageZipUpload(formData);
    // console.log(res);
    // 목록 화면의 디자인 타입 셀렉 박스 값을 반영시키기 위해 파라미터를 보낸다.
    fetchData(inputDatas.design_type);
    setSelectDesignType(inputDatas.design_type);
    setInputDatas({ image_name: '', design_type: selectDesignType });
    setFile(null);
    form.resetFields(); // 드롭존 이미지를 비우기 위해 필요하다.
    setVisible(false);
    message.success(t('platformimg.createImageTypeModal.successMessage'), 1);
  };
  useEffect(() => {
    if (selectDesignType) {
      setInputDatas({ ...inputDatas, design_type: selectDesignType });
    }
  }, []);
  return (
    <SmallModal
      title={t('platformimg.zipUploadModal.title')}
      visible={visible}
      onCancel={handleClose}
    >
      <VerticalForm form={form} drop>
        <Form.Item label={t('platformimg.zipUploadModal.imageType')}>
          <DefaultSelect
            optionList={optionList}
            value={inputDatas.design_type}
            onChange={handleChangeDesignType}
          />
        </Form.Item>
        <Form.Item name='uploadFile'>
          <DropZoneZip setFile={setFile} zipMemo='jpg, png' />
        </Form.Item>
        <SubmitButton onClick={handleSubmit}>
          {t('platformimg.zipUploadModal.register')}
        </SubmitButton>
      </VerticalForm>
    </SmallModal>
  );
};

export default PlatformImgZipUploadModal;
